import { create } from "zustand";
import { clearRecent } from "@/shared/hooks/useRecentlyViewed";
import type { User } from "../types";

interface AuthState {
	user: User | null;
	/**
	 * Faqat xotirada. `localStorage`ga yozilmaydi — XSS orqali o'g'irlanmasligi uchun.
	 * Refresh token httpOnly cookie'da va JS uchun umuman ko'rinmaydi.
	 */
	accessToken: string | null;
	isAuthenticated: boolean;
	isLoading: boolean;
}

interface AuthActions {
	setAuth: (user: User, accessToken: string) => void;
	setAccessToken: (accessToken: string) => void;
	setUser: (user: User) => void;
	setLoading: (loading: boolean) => void;
	logout: () => void;
}

type AuthStore = AuthState & AuthActions;

export const useAuthStore = create<AuthStore>((set) => ({
	user: null,
	accessToken: null,
	isAuthenticated: false,
	// Boot paytida jimgina refresh urinishi bo'ladi, shuning uchun true'dan boshlanadi.
	isLoading: true,

	setAuth: (user, accessToken) => {
		set({ user, accessToken, isAuthenticated: true, isLoading: false });
	},

	setAccessToken: (accessToken) => {
		set({ accessToken });
	},

	setUser: (user) => {
		set({ user, isAuthenticated: true, isLoading: false });
	},

	setLoading: (loading) => {
		set({ isLoading: loading });
	},

	/**
	 * ⚠️ «Yaqinda ko'rilgan» ro'yxati SHU YERDA tozalanadi, `useLogout` da
	 * EMAS. Sabab: chiqishning IKKI yo'li bor va ikkinchisi hook'ni umuman
	 * chetlab o'tadi — `app/api/client.ts` refresh yiqilganda (sessiya
	 * muddati tugaganda) to'g'ridan-to'g'ri `useAuthStore.getState().logout()`
	 * ni chaqiradi. Tozalash faqat tugma yo'lida bo'lsa, umumiy bank ish
	 * stantsiyasida muddati tugagan sessiyadan keyin keyingi foydalanuvchi
	 * oldingisining lid va topshiriq nomlarini bosiladigan havolalar bilan
	 * ko'rardi — bu esa aynan ushbu ro'yxat yopishi kerak bo'lgan oqish.
	 */
	logout: () => {
		clearRecent();
		set({ user: null, accessToken: null, isAuthenticated: false, isLoading: false });
	},
}));
